import { Request } from "./request";

export const apiGetPrizes = async (filters = {}) => {
  return Request.call({
    url: `/api/watch/prizes`,
    method: "GET",
    params: filters,
  });
};
